export const tagVrcFuryReady = 'vrcfury_ready' // copied from database
